<template>
  <div class="card">
    <div class="card-header bg-white">
      <div class="row">
        <div class="col">
          <h2>{{ title }}</h2>
        </div>
        <div class="col-auto">
          <button type="button" class="close cursor-pointer" @click="$emit('close')"><span aria-hidden="true">×</span></button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <slot name="body">

      </slot>
    </div>
    <div v-if="showFooter" class="card-footer bg-white">
      <div class="row">
        <div class="col text-right">
          <slot name="footer">

          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {},
    showFooter: {}
  },
};
</script>

<style lang="scss" scoped>
.close {
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem auto;
}

.card-header {
  padding: 1rem 1rem;
}
</style>